import tunnel from 'tunnel-rat';

export const kanbanTunnel = tunnel();
